import type { ReactNode } from 'react';

interface ProfileFieldProps {
    label: string;
    value: ReactNode;
    valueClassName?: string;
    containerClassName?: string;
}

export default function ProfileField({
    label,
    value,
    valueClassName = 'font-semibold',
    containerClassName = 'flex justify-between text-base',
}: ProfileFieldProps) {
    return (
        <div className={containerClassName}>
            <dt className="text-gray-500">{label}</dt>
            <dd className={`text-right ${valueClassName}`}>{value}</dd>
        </div>
    );
}
